export const CatalogNotFoundContent = {
  title: 'Nenhum catálogo foi encontrado.',
  auxiliar:
    'Avise seu revendedor para que ele possa apresentar outras maneiras de continuar a compra.',
}
